import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  QueryList,
  SecurityContext,
  SimpleChanges,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { LoginStoreEffects } from '@app/root-store/login-store/effects';
import { AutoUnsubscribe } from '@app/shared/decorators/auto-unsubscribe.decorator';
import { CommonService, DocumentService } from '@app/shared/services';
import { CryptoService } from '@app/shared/services/crypto/crypto.services';
import { NotesService } from '@app/shared/services/notes/notes.service';
import { formatISODateToReadable, formatTimestamp } from '@app/shared/utils';
import { fromEvent, Observable, Subscription } from 'rxjs';

@AutoUnsubscribe()
@Component({
  selector: 'manage-activity',
  templateUrl: './manage-activity.component.html',
  styleUrls: ['./manage-activity.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ManageActivityComponent implements OnInit, OnDestroy {
  @Input() fId;
  @Input() sk;
  @Input() files;
  @Input() fileId;
  @Input() selectedSecurity_key: any = null;

  screenWidth: number;
  notesForm: UntypedFormGroup;
  notesList: Array<any> = [];
  editNotesItem = [];
  currentValue: Array<any> = [];
  activiyLogList = [];
  noteUpdatedValue;
  prevIndex;
  userId$: Observable<any>;
  subscription = new Subscription();
  showLoader = true;
  formUserPublicKey = false;
  showHistoryLoader = true;
  securityStateObject;
  emailInformation: any = {};
  resizeObservable$: Observable<Event>;
  commentsCount = 0;
  historyCount = 0;
  emailInformationCount = 0;

  @ViewChildren('notes') notes: QueryList<any>;
  @ViewChild('content') content: ElementRef;
  // @ViewChild('myTextarea') set myTextareaRef(ref: ElementRef) {
  //   if (!!ref) {
  //     ref.nativeElement.focus();
  //   }
  // }

  constructor(
    private cd: ChangeDetectorRef,
    private documentService: DocumentService,
    private _fb: UntypedFormBuilder,
    private notesService: NotesService,
    private cryptoService: CryptoService,
    private commonService: CommonService,
    private router: Router,
    private sanitizer: DomSanitizer,
    private loginService: LoginStoreEffects
  ) {
    this.subscription.add(
      this.loginService.loginObject.subscribe((res) => {
        this.userId$ = { ...res.data };
      })
    );
  }

  public_key() {
    return this.securityStateObject.public_key;
  }

  ngOnInit(): void {
    this.screenWidth = window.innerWidth;
    this.resizeObservable$ = fromEvent(window, 'resize');
    this.subscription.add(
      this.resizeObservable$.subscribe((evt) => {
        this.screenWidth = evt.target['innerWidth'];
      })
    );

    this.notesForm = this._fb.group({
      addNote: ['', Validators.required],
    });

    this.getFormNote(this.fileId);
    this.showFileHistory();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['files']) {
      const currentFile = changes['files']?.currentValue[0];
      this.emailInformation = {
        message_textAsHtml: this.sanitizer.sanitize(SecurityContext.HTML, currentFile?.message_textAsHtml),
        message_subject: currentFile?.message_subject,
        formattedDate: formatISODateToReadable(currentFile?.created_at),
        from_name: currentFile?.from_name,
        from_email: currentFile?.from_email,
      };

      this.emailInformationCount = this.emailInformation?.message_textAsHtml ? 1 : 0;
      this.cd.detectChanges();
    }
  }

  showFileHistory() {
    this.subscription.add(
      this.documentService.getFileActivityLog(this.fileId).subscribe((res) => {
        this.activiyLogList = res?.data;
        this.activiyLogList.map((item) => {
          item.formattedDate = formatTimestamp(item.when);
        });
        this.showHistoryLoader = false;
        this.historyCount = this.activiyLogList?.length || 0;
        this.cd.detectChanges();
      })
    );
  }

  getFormNote(checklistId) {
    this.subscription.add(
      this.notesService.getForm(checklistId, 'form').subscribe((res) => {
        this.securityStateObject = res.public_key;
        const notesArr = [...res.data];
        this.notesList = notesArr.map((item) => {
          return (item = { ...item, isHeader: false });
        });
        this.notesList.map((item, i) => {
          this.notesList[0].isHeader = true;
          if (i < this.notesList.length - 1) {
            let index = i + 1;
            if (this.notesList[i]?.user_id == this.notesList[index]?.user_id) {
              this.notesList[index].isHeader = false;
            } else {
              this.notesList[index].isHeader = true;
            }
          }
          item.formattedDate = formatTimestamp(item.create_timestamp);
          return this.notesList;
        });

        this.notesList.forEach((element) => {
          try {
            if (this.selectedSecurity_key) {
              let jsonNotes = JSON.parse(element.notes);
              if (jsonNotes.key && jsonNotes.data) {
                let data = this.cryptoService.decryptData(jsonNotes, this.selectedSecurity_key, this.sk);
                element.notes = JSON.parse(data);
              }
            }
          } catch (error) {
            console.error('error', error);
          }
        });

        this.showLoader = false;
        this.commentsCount = this.notesList?.length || 0;
        this.cd.markForCheck();
      })
    );
  }
  saveAllNotes(selectedSecurity_key) {
    this.selectedSecurity_key = selectedSecurity_key;
    this.notesList.forEach((notes_item) => {
      const payload = {
        notes: notes_item.notes,
        update_timestamp: this.commonService.getCurrentDateInEpoch(),
        id: notes_item.id,
        user_pk: this.public_key(),
      };

      this.subscription.add(this.notesService.createNoteWithEncryption(payload, this.selectedSecurity_key, false).subscribe());
    });
  }

  createNote(noteType, item, i) {
    if (noteType == 'editnotes' && this.noteUpdatedValue) {
      const payload = {
        notes: this.noteUpdatedValue,
        update_timestamp: this.commonService.getCurrentDateInEpoch(),
        id: item.id,
        user_pk: this.public_key(),
      };

      this.subscription.add(
        this.notesService.createNoteWithEncryption(payload, this.selectedSecurity_key, false).subscribe((res) => {
          if (res) {
            this.notesList[i].id = res.id;
            // this.notesList[i].notes = res.notes;
            this.notesList[i].create_timestamp = res.update_timestamp;
            this.cd.markForCheck();
          }
        })
      );

      this.editNotesItem[i] = false;
      eval(`document.getElementById("${'notes-input' + i}").style.background='white'`);
    } else if (noteType == 'editnotes' && !this.noteUpdatedValue) {
      this.clearNotes(i);
    } else {
      if (this.notesForm.controls['addNote'].value) {
        const payload = {
          notes: this.notesForm.controls['addNote'].value,
          create_timestamp: this.commonService.getCurrentDateInEpoch(),
          type: 'form',
          type_id: this.fileId,
          user_pk: this.public_key(),
        };

        this.subscription.add(
          this.notesService.createNoteWithEncryption(payload, this.selectedSecurity_key).subscribe((res) => {
            if (res) {
              if (this.notesList.length >= 1) {
                const date = new Date(0);
                date.setUTCSeconds(res.create_timestamp);
                const newNotes = {
                  first_name: this.userId$['first_name'],
                  last_name: this.userId$['last_name'],
                  profile_image_url: this.userId$['profile_image_url'],
                  id: res.id,
                  notes: this.notesForm.controls['addNote'].value,
                  formattedDate: formatTimestamp(res.create_timestamp),
                  type_id: res.type_id,
                  user_id: this.userId$['id'],
                };

                const length = this.notesList.length - 1;
                if (this.notesList[length].user_id == this.userId$['id']) {
                  newNotes['isHeader'] = false;
                } else {
                  newNotes['isHeader'] = true;
                }
                // this.notesList.push(newNotes);
                this.notesList = [newNotes, ...this.notesList];
                this.commentsCount = this.notesList?.length || 0;
                this.notesForm.reset();
              } else {
                this.notesForm.reset();
                this.getFormNote(this.fileId);
              }
              this.notesForm.reset();
              this.editNotesItem[i] = false;

              this.cd.markForCheck();
            }
          })
        );
      }
    }
  }

  editNotes(item, i) {
    if (this.prevIndex >= 0 && this.prevIndex != null) {
      this.editNotesItem[this.prevIndex] = false;
      this.editNotesItem[i] = true;
      this.prevIndex = i;
      eval(`document.getElementById("${'notes-input' + i}").focus()`);
    } else {
      this.prevIndex = i;
      this.editNotesItem[i] = true;
      eval(`document.getElementById("${'notes-input' + i}").focus()`);
    }

    let temp = item;
    temp['notes_initial'] = item.notes;
    this.currentValue = temp;
  }

  onNoteChange(event, i) {
    this.noteUpdatedValue = event;
  }

  deleteNote(id, i) {
    this.subscription.add(
      this.notesService.deleteNote(id).subscribe((res) => {
        this.notesList = this.notesList.filter((item) => {
          item = item.id != id;
          return item;
        });

        this.commentsCount = this.notesList?.length || 0;
        this.cd.markForCheck();
      })
    );
  }

  clearNotes(i) {
    this.notesList[i].notes = this.currentValue['notes_initial'];
    this.editNotesItem[i] = false;
    // eval(`document.getElementById("${'notes-input' + i}").blur()`);
    eval(`document.getElementById("${'notes-input' + i}").style.background='white'`);
    this.cd.detectChanges();
  }

  getCurrentDate(timestamp) {
    return this.commonService.getCurrentDateFromUnixTimestamp(timestamp);
  }

  getCurrentTime(timestamp) {
    return this.commonService.getTimeConvertedFromEpoch(timestamp);
  }

  scrollToBottom = () => {
    try {
      this.content.nativeElement.scrollTop = this.content.nativeElement.scrollHeight;
    } catch (err) {}
  };

  closeDialog() {
    this.notesForm.controls['addNote'].patchValue(null);
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }
}
